import SportTeamsNearLocationBlock from './SportTeamsNearLocationBlock';
import { SportTeamsNearLocationBlockProps, SportTeamsNearLocationBlockValueProps } from './types';

export type { SportTeamsNearLocationBlockProps, SportTeamsNearLocationBlockValueProps };
export default SportTeamsNearLocationBlock;
